<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="20"
    height="20"
  >
    <g transform="translate(7.5 1.25)">
      <path
        d="M457.486,62.623a1.989,1.989,0,1,1-1.988-1.989,1.988,1.988,0,0,1,1.988,1.989"
        transform="translate(-453.105 -60.634)"
        :fill="color"
      />
      <path
        d="M455.1,76.877h0a2.391,2.391,0,0,1-2.392-2.391V70.629a2.392,2.392,0,0,1,4.783,0v3.856a2.391,2.391,0,0,1-2.391,2.391"
        transform="translate(-452.71 -64.402)"
        :fill="color"
      />
      <path
        d="M455.008,89.08h0a.679.679,0,0,1-.679-.679V82.439h1.358V88.4a.679.679,0,0,1-.679.679"
        transform="translate(-453.512 -71.438)"
        :fill="color"
      />
      <path
        d="M458.56,89.08h0a.679.679,0,0,1-.679-.679V82.439h1.358V88.4a.679.679,0,0,1-.679.679"
        transform="translate(-455.272 -71.438)"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script>
export default {
  computed: {
    color: ({ $store }) => $store.getters['map/includesPersonsPin'] ? '#0174bf' : '#9d9d9d',
  },
};
</script>



// WEBPACK FOOTER //
// person.vue?2430d65c